import * as actionTypes from 'actions/driverManagementActions';

const initialState = {
  drivers: [],
  filter: {
    admin: true,
    driver: true,
    accountant: true,
    manager: true,
    hr: true,
    sale: true,
    warehouse: true,
    tinh_cuoc: true,
    hcns: true
  },
  loading: false,
  selectedDriver: [],
  formState: {
    open: false,
    edit: false,
    username: '',
    fullname: '',
    role: 'driver',
    avatar: '',
    email: '',
    role_name: '',
    note: '',
    ngay_thang_nam_sinh: new Date('1990/1/1'),
    que_quan: '',
    dia_chi: '',
    so_cccd: '',
    trang_thai: 'Đang làm',
    ngay_bat_dau: new Date('2022/1/1')
  }
};

const driverManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_DRIVER: {
      return {
        ...state,
        drivers: action.drivers,
        loading: false,
        selectedDriver: []
      };
    }

    case actionTypes.SET_FILTER: {
      return {
        ...state,
        filter: { ...state.filter, ...action.filter }
      };
    }

    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.loading
      };
    }

    case actionTypes.SET_SELECTED_DRIVER: {
      return {
        ...state,
        selectedDriver: action.selected
      };
    }

    case actionTypes.UPDATE_FORM: {
      return {
        ...state,
        formState: { ...state.formState, ...action.formState }
      };
    }

    default: {
      return state;
    }
  }
};

export default driverManagementReducer;
